export default __webpack_public_path__ + "static/media/2k_earth_specular_map.0779abe8.jpg";